/*
 * Define a page to prompt the user for the court name and case number.
 */
import * as yup from 'yup'
import css from '../../../ComplaintForm/ComplaintForm.module.css'
import { choicePage } from '../../../../pages'
import { genericMessage } from '../../../../strings/messages'
import { dateYupOptional, selectionRequired } from '../../../../validators'

export const courtOrderPage = propOverrides => {
  const yes = 'Yes'
  const no = 'No'
  const props = {
    pageId: 'court_order',
    fieldName: 'court_order_exists_yn',
    choices: [{ label: yes, value: yes }, { label: no, value: no }],
    conditionalValue: yes,
    className: css.choices,
    labelClassName: css.largeLabel,
    label: 'Is there a valid court order for the child support?',
    ...propOverrides
  }

  const validation = yup.object().shape({
    [props.fieldName]: selectionRequired(),
    court_name: yup
      .string()
      .max(100, 'Court name cannot have more than 100 characters.')
      .test('court_name_req', genericMessage, function(value) {
        const selectedValue = this.parent[props.fieldName]
        if (selectedValue && selectedValue.includes(props.conditionalValue))
          return value != null
        return true
      }),
    case_number: yup
      .string()
      .max(20, 'Case number cannot have more then 20 characters.')
      .test('case_number_req', genericMessage, function(value) {
        const selectedValue = this.parent[props.fieldName]
        if (selectedValue && selectedValue.includes(props.conditionalValue))
          return value != null
        return true
      }),
    court_order_date: dateYupOptional()
  })

  const conditionals = [
    {
      value: props.conditionalValue,
      fields: [
        {
          type: 'text',
          label: 'Please enter the name of the court',
          name: 'court_name',
          autoFocus: true
        },
        {
          type: 'text',
          label: 'Please enter the court case number',
          name: 'case_number'
        },
        {
          type: 'date',
          label: 'Date of first court order',
          name: 'court_order_date',
          overrideDefaultMinMax: true
        }
      ]
    }
  ]

  return choicePage({ validation, conditionals, ...props })
}
